// A utility to filter out specific console logs in production

// Store original console methods
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
};

// Patterns to filter in production
const filterPatterns = [
  /Encountered two children with the same key/,
  /react-router/,
  /Warning:/,
  /Blocked aria-hidden/,
  /favicon\.ico/,
];

// Only apply in production
const isProduction = process.env.NODE_ENV === 'production';

// Helper to check if a message matches any of our filter patterns
const shouldFilter = (args: any[]): boolean => {
  if (!isProduction) return false;
  
  const message = args[0]?.toString() || '';
  return filterPatterns.some(pattern => pattern.test(message));
};

// Setup console overrides
export const setupConsoleFilters = (): void => {
  if (!isProduction) return;
  
  console.warn = function(...args: any[]) {
    if (!shouldFilter(args)) {
      originalConsole.warn.apply(console, args);
    }
  };
  
  console.error = function(...args: any[]) {
    if (!shouldFilter(args)) {
      originalConsole.error.apply(console, args);
    }
  };
  
  // Suppress all console.log in production
  console.log = function() {};
};

// Function to restore original console behavior if needed
export const restoreConsole = (): void => {
  console.log = originalConsole.log;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
};

export default setupConsoleFilters; 